import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../elements/logo/Logo';
import useStickyHeader from './useStickyHeader';
import { currency_list, getUnreadMessages, getUserId, isLoggedIn, USER_ROLE } from '../../utils';
import { get } from '../../utils/api_helper';
import { Button, DropdownButton } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { FiLogOut, FiShoppingCart } from 'react-icons/fi';
import { MdOutlineSpaceDashboard } from 'react-icons/md';
import { CgProfile } from 'react-icons/cg';
import { AiFillEdit, AiFillShop, AiOutlineBars, AiOutlineCaretDown, AiOutlineShoppingCart, AiOutlineClose } from 'react-icons/ai';
import { CiUser } from 'react-icons/ci';
import { MdOutlineTrackChanges } from "react-icons/md";
import { CiShop } from "react-icons/ci";
import { AiOutlineMessage, AiOutlineMail } from 'react-icons/ai';
import axios from 'axios';
import { RiProfileLine } from 'react-icons/all';
import * as api from '../../utils/api_helper';
import Select from 'react-select';
import { languages } from '../../utils/constants';
import { useCookies } from 'react-cookie';
import { BsHeartFill } from 'react-icons/bs';
import SearchBar from './SearchBar';
import './HeaderOne.scss';

const HeaderOne = ({ btnStyle, HeaderSTyle, showSlider = true }) => {
  const [userData, setUserData] = useState('');
  let [check, setCheck] = useState(true);
  const sticky = useStickyHeader(50);
  const headerClasses = `header-default ${sticky && check ? 'sticky' : ''}`;
  const [refetch, setRefetch] = useState(0);
  const [registered, setRegistered] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currency, setCurrency] = useState('usd');
  const [companyID, setCompanyID] = useState('');
  const [messageNotification, setMessageNotification] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cur, setCur] = useState(localStorage.getItem('cur') || 'USD');
  const [cookies, setCookie] = useCookies(['googtrans']);
  const [language, setLanguage] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const userId = getUserId();
  const ref = useRef();

  // Custom styles for language and currency react select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      height: '30px',
      padding: '5px',
      'fontSize': '12px',
    }),
    control: (provided, state) => ({
      ...provided,
      'background-color': 'white',
      'text-align': 'left',
      'vertical-align': 'left',
      'fontSize': '14px',
    }),
    singleValue: (provided, state) => {
      const transition = 'opacity 300ms';
      return { ...provided, transition };
    },
  };

  // Get IP Address for currency 
  const getIpAddress = async () => {
    await axios
      .get('https://geolocation-db.com/json/')
      .then((res) => {
        getCurrencyFromIP(res?.data?.IPv4);
      })
      .catch((err) => {
        console.error('Error fetching IP location', err);
        getCurrencyFromIP('');
      });
  };

  // Get currency from IP address
  const getCurrencyFromIP = async (ipAddress) => {
    if (ipAddress) {
      await axios
        .get('https://ipapi.co/' + ipAddress + '/currency/')
        .then((res) => {
          setCurrency(res.data);
          localStorage.setItem('cur', res.data);
          window.location.reload(true);
        })
        .catch((err) => {
          console.error('Error fetching currency from IP address', err);
        });
    } else {
      setCurrency('USD');
    }
  };

  // Handle setting currencies
  useEffect(() => {
    const body = document.body;
    body.classList.add("light")
    const googleTransCookie = cookies?.googtrans;
    setLanguage(googleTransCookie ? googleTransCookie.split('/')[2] : 'en');
    const currentCurrency = localStorage.getItem('cur');
    if (!currentCurrency) {
      getIpAddress();
    }
  }, []);

  // Handle save for saving currency and language preferences
  const saveLanguageAndCurrency = async () => {
    const googleTransCookie = cookies?.googtrans;
    const currentLanguage = googleTransCookie ? googleTransCookie.split('/')[0] : 'en';
    setCookie('googtrans', `/${currentLanguage}/${selectedLanguage}`);
    localStorage.setItem('cur', selectedCurrency);
    setCur(selectedCurrency);
    window.location.reload(true);
  }

  useEffect(() => {
    // Get unread messages
    async function getCount() {
      const resp = await getUnreadMessages();
      setMessageNotification(resp);
    }

    // Get cart count
    async function getCartCount() {
      if (userId) {
        api
          .get('/cart/user/' + userId)
          .then((response) => {
            if (response[0]) {
              if (response[0].product_title) {
                setCartCount(response[0].product_title.split(';').length);
              } else {
                setCartCount(0);
              }
            }
          })
          .catch((error) => {
            console.error('Error fetching cart', error);
          });
      }
    }
    if (isLoggedIn()) {
      getCount();
      getCartCount();
      setTimeout(() => { setRefetch(refetch + 1); }, 5000);
    }
  }, [refetch]);

  useEffect(() => {
    if (userId) {
      async function getUserName() {
        await get('/users/' + userId)
          .then((resp) => {
            setUserData(resp);
            if (resp?.role == USER_ROLE.ADMIN) {
              setIsAdmin(true);
            }
          })
          .catch((err) => {
            console.error('error', err);
          });
      }
      getUserName();
    }
  }, []);

  useEffect(() => {
    if (userId) {
      async function getUserName() {
        await get('/companies/user/' + userId)
          .then((resp) => {
            if (resp && Array.isArray(resp) && resp.length > 0 && resp[0].id) {
              setRegistered(true);
              setCompanyID(resp[0].id);
            }
          })
          .catch((err) => {
            console.error('error', err);
          });
      }
      getUserName();
    }
  }, []);

  // Currency constant for react select
  const currencyOptions = currency_list.map((item) => ({
    value: item.code,
    label: `${item.name} ${item.code}`,
    image: `/images/country-flags/${item.img}.png`
  }));

  // Handle select change
  const handleSelectChange = async (value, action) => {
    if (action.name == 'currency') {
      setSelectedCurrency(value.value);
    } else if (action.name == 'language') {
      setSelectedLanguage(value.value);
    }
  }

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.hamburger-btn')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  return (
    <>
      <header ref={ref} className={`rn-header header-default ${HeaderSTyle} ${headerClasses}`}>
        <div className="position-relative container">
          <div className="row align-items-center row--0">
            {/* Logo Section */}
            <div className="col-lg-2 col-6">
              <Logo
                image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                image2={`${process.env.PUBLIC_URL}/images/logo/logo-dark.png`}
              />
            </div>

            {/* Search Section - Added search-section class */}
            <div className="col-lg-6 col-12 mt-2 mb-2 order-3 order-lg-2 search-section">
              <SearchBar />
            </div>

            {/* Desktop Menu & Mobile Hamburger */}
            <div className="col-lg-4 col-6 order-2 order-lg-3">
              {/* Mobile Hamburger Button */}
              <div className="d-lg-none text-right">
                <Button
                  className="hamburger-btn btn btn-link p-2"
                  onClick={toggleMobileMenu}
                  style={{ border: 'none', background: 'transparent' }}
                >
                  {mobileMenuOpen ? (
                    <AiOutlineClose size={24} />
                  ) : (
                    <AiOutlineBars size={24} />
                  )}
                </Button>
              </div>

              {/* Desktop Menu */}
              <div className="header-right d-none d-lg-block">
                <div className="dropdown-homepage row">
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='ml-2'>
                      <div className="auth-box cursor-pointer">
                        <CiShop size={24} className="auth-icon" />
                        <Link to="/users/register" className="auth-text">
                          <span className="auth-link auth-primary">Become a</span>
                          <span className="auth-link auth-primary">Supplier</span>
                        </Link>
                      </div>
                    </div>

                    <div className='ml-2'>
                      <div className="auth-box cursor-pointer">
                        <MdOutlineTrackChanges size={22} className="auth-icon" />
                        <Link to="/view-sourcing-request" className="auth-text">
                          <span className="auth-link auth-primary">Sourcing</span>
                          <span className="auth-link auth-primary">Request</span>
                        </Link>
                      </div>
                    </div>

                    {/* Language/Currency Selector */}
                    <div className='ml-2 mr-2'>
                      <div className="auth-box cursor-pointer" onClick={() => setOpenDropdown(!openDropdown)}>
                        <div className="auth-text">
                          <span className="auth-link auth-primary">{language.toUpperCase()}/</span>
                          <span className="auth-link auth-primary">{cur.toUpperCase()}</span>
                        </div>
                      </div>

                      <div className={openDropdown ? '' : 'd-none '} style={{ position: "absolute", top: 60, right: 0, backgroundColor: "#fff", width: "250px", borderRadius: '10px', zIndex: 1000, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                        <div className="mt-1 px-3 pt-4 ">
                          <div className='custom-switcher'>
                            <div className='switch-item'>
                              <p className='label no-margin'>Language</p>
                              <div className='skipMyTranslate'>
                                <div className='skiptranslate'>
                                  <Select
                                    name='language'
                                    options={languages}
                                    styles={customStyles}
                                    onChange={handleSelectChange}
                                    value={!selectedLanguage ? { label: languages.find(option => option.value == language)?.label } : { label: languages.find(option => option.value == selectedLanguage)?.label }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='switch-item mt-3'>
                              <p className='label no-margin'>Currency</p>
                              <div className='skipMyTranslate'>
                                <div className='skiptranslate'>
                                  <Select
                                    name='currency'
                                    options={currencyOptions}
                                    styles={customStyles}
                                    onChange={handleSelectChange}
                                    value={!selectedCurrency
                                      ? { label: currencyOptions.find(option => option.value === cur)?.label, image: currencyOptions.find(option => option.value === cur)?.image }
                                      : { label: currencyOptions.find(option => option.value === selectedCurrency)?.label, image: currencyOptions.find(option => option.value === selectedCurrency)?.image }
                                    }
                                    formatOptionLabel={country => (
                                      <div className="country-option">
                                        <img width="15px" height="15px" src={country.image} />
                                        &nbsp;<span>{country.label}</span>
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='text-center'>
                              <Button onClick={saveLanguageAndCurrency} className="mt-3 btn-default btn-small mb-3" style={{ width: '100%' }}>Save</Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* User Authentication/Profile */}
                    {isLoggedIn() ? (
                      <>
                        <DropdownButton
                          className="float-left dropdown-button"
                          drop="down"
                          title={
                            <a>
                              <span className="avatar-small">
                                {userData && userData.username.charAt(0)}
                              </span>
                              <span
                                style={{ fontSize: '14px' }}
                                className="color-black ml-2 text-lowercase username"
                              >
                                {userData.username}
                              </span>
                            </a>
                          }
                          size="lg"
                          id="nav-dropdown "
                        >
                          <div className="user-corner" />
                          <div className="avatar text-center">
                            <span className="avatar-big">
                              {userData && userData.username.charAt(0)}
                            </span>
                            <h5 className="mb-0">{userData.username}</h5>
                            <label>{userData.email}</label>
                          </div>
                          <DropdownItem className="dropdown-link" href="/users/dashboard">
                            <MdOutlineSpaceDashboard />
                            &nbsp;Dashboard
                          </DropdownItem>
                          <DropdownItem className="dropdown-link" href="/users/product-wishlist">
                            <BsHeartFill />
                            &nbsp;Wishlist
                          </DropdownItem>
                          <DropdownItem className="dropdown-link" href="/users/messages">
                            <AiOutlineMessage />
                            &nbsp;Messages
                          </DropdownItem>
                          <DropdownItem
                            className="dropdown-link company-profile-menu"
                            href={'/company-details/' + companyID}
                          >
                            <RiProfileLine />
                            &nbsp;Company Profile
                          </DropdownItem>
                          <DropdownItem
                            className="dropdown-link edit-company "
                            href={'/users/company-registration'}
                          >
                            <span className="ml-5">
                              <AiFillEdit />
                              &nbsp;Edit Company
                            </span>
                          </DropdownItem>
                          <DropdownItem className="dropdown-link my-shop" href={'users/listings'}>
                            <AiFillShop />
                            &nbsp;My Shop
                          </DropdownItem>
                          <DropdownItem
                            className="dropdown-link edit-products"
                            href={'/users/add-product'}
                          >
                            <span className="ml-5">
                              <AiFillEdit />
                              &nbsp;Add Products
                            </span>
                          </DropdownItem>
                          <DropdownItem className="dropdown-link" href="/users/profile">
                            <CgProfile />
                            &nbsp;Account Details
                          </DropdownItem>
                          <DropdownItem className="dropdown-link" href="/users/logout">
                            <FiLogOut />
                            &nbsp;Logout
                          </DropdownItem>
                        </DropdownButton>
                        <div className="icon-wrapper">
                          <a href="/cart">
                            <FiShoppingCart color="black" size={20} />
                            <span className="cart-badge">{cartCount}</span>
                          </a>
                        </div>

                        <div className="icon-wrapper">
                          <a href="/users/messages">
                            <AiOutlineMail color="black" size={20} />
                            <span className="mail-badge">{messageNotification}</span>
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="auth-box">
                        <CiUser size={22} className="auth-icon" />
                        <div className="auth-text">
                          <a href="/users/login" className="auth-link auth-primary">Sign in /</a>
                          <a href="/users/register" className="auth-link auth-primary">Register</a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div
            className="mobile-menu-overlay d-lg-none"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 998
            }}
            onClick={() => setMobileMenuOpen(false)}
          />
        )}

        {/* Mobile Menu */}
        <div
          className={`mobile-menu d-lg-none ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}
          style={{
            position: 'fixed',
            top: 0,
            right: mobileMenuOpen ? 0 : '-300px',
            width: '280px',
            height: '100vh',
            backgroundColor: '#fff',
            boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
            transition: 'right 0.3s ease',
            zIndex: 999,
            overflowY: 'auto',
            padding: '20px'
          }}
        >
          {/* Mobile Menu Header */}
          <div className="mobile-menu-header d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">Menu</h5>
            <button
              className="btn btn-link p-0"
              onClick={() => setMobileMenuOpen(false)}
              style={{ border: 'none', background: 'transparent' }}
            >
              <AiOutlineClose size={24} />
            </button>
          </div>

          {/* Mobile Menu Items */}
          <div className="mobile-menu-items">
            {/* Search Bar in Mobile Menu - Only shown when sticky */}
            {sticky && (
              <div className="mobile-menu-item mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
                <SearchBar />
              </div>
            )}

            {/* Become a Supplier */}
            <div className="mobile-menu-item mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
              <Link to="/users/register" className="d-flex align-items-center text-decoration-none">
                <CiShop size={24} className="mr-3" />
                <div>
                  <div className="font-weight-bold">Become a Supplier</div>
                </div>
              </Link>
            </div>

            {/* Sourcing Request */}
            <div className="mobile-menu-item mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
              <Link to="/view-sourcing-request" className="d-flex align-items-center text-decoration-none">
                <MdOutlineTrackChanges size={24} className="mr-3" />
                <div>
                  <div className="font-weight-bold">Sourcing Request</div>
                </div>
              </Link>
            </div>

            {/* Language & Currency */}
            <div className="mobile-menu-item mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
              <div className="font-weight-bold mb-2">Language & Currency</div>
              <div className="mb-2">
                <small className="text-muted">Language</small>
                <Select
                  name='language'
                  options={languages}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  value={!selectedLanguage ? { label: languages.find(option => option.value == language)?.label } : { label: languages.find(option => option.value == selectedLanguage)?.label }}
                />
              </div>
              <div className="mb-2">
                <small className="text-muted">Currency</small>
                <Select
                  name='currency'
                  options={currencyOptions}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  value={!selectedCurrency
                    ? { label: currencyOptions.find(option => option.value === cur)?.label, image: currencyOptions.find(option => option.value === cur)?.image }
                    : { label: currencyOptions.find(option => option.value === selectedCurrency)?.label, image: currencyOptions.find(option => option.value === selectedCurrency)?.image }
                  }
                  formatOptionLabel={country => (
                    <div className="country-option">
                      <img width="15px" height="15px" src={country.image} alt="" />
                      &nbsp;<span>{country.label}</span>
                    </div>
                  )}
                />
              </div>
              <Button onClick={saveLanguageAndCurrency} className="mt-3 btn-default btn-small mb-3 w-100">
                Save Settings
              </Button>
            </div>

            {/* User Section */}
            {isLoggedIn() ? (
              <div className="mobile-menu-item">
                <div className="user-info mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                  <div className="d-flex align-items-center mb-2">
                    <span className="avatar-small mr-2">
                      {userData && userData.username.charAt(0)}
                    </span>
                    <div>
                      <div className="font-weight-bold">{userData.username}</div>
                      <small className="text-muted">{userData.email}</small>
                    </div>
                  </div>
                </div>

                <div className="user-menu-links">
                  <a href="/users/dashboard" className="d-flex align-items-center py-2 text-decoration-none">
                    <MdOutlineSpaceDashboard className="mr-3" />
                    Dashboard
                  </a>
                  <a href="/users/product-wishlist" className="d-flex align-items-center py-2 text-decoration-none">
                    <BsHeartFill className="mr-3" />
                    Wishlist
                  </a>
                  <a href="/users/messages" className="d-flex align-items-center py-2 text-decoration-none">
                    <AiOutlineMessage className="mr-3" />
                    Messages
                    {messageNotification > 0 && (
                      <span className="badge bg-danger rounded-pill ml-auto">
                        {messageNotification}
                      </span>
                    )}
                  </a>
                  <a href={'/company-details/' + companyID} className="d-flex align-items-center py-2 text-decoration-none">
                    <RiProfileLine className="mr-3" />
                    Company Profile
                  </a>
                  <a href="/users/company-registration" className="d-flex align-items-center py-2 text-decoration-none">
                    <AiFillEdit className="mr-3" />
                    Edit Company
                  </a>
                  <a href="users/listings" className="d-flex align-items-center py-2 text-decoration-none">
                    <AiFillShop className="mr-3" />
                    My Shop
                  </a>
                  <a href="/users/add-product" className="d-flex align-items-center py-2 text-decoration-none">
                    <AiFillEdit className="mr-3" />
                    Add Products
                  </a>
                  <a href="/cart" className="d-flex align-items-center py-2 text-decoration-none">
                    <FiShoppingCart className="mr-3" />
                    Cart
                    {cartCount > 0 && (
                      <span className="badge bg-danger rounded-pill ml-auto">
                        {cartCount}
                      </span>
                    )}
                  </a>
                  <a href="/users/profile" className="d-flex align-items-center py-2 text-decoration-none">
                    <CgProfile className="mr-3" />
                    Account Details
                  </a>
                  <a href="/users/logout" className="d-flex align-items-center py-2 text-decoration-none text-danger">
                    <FiLogOut className="mr-3" />
                    Logout
                  </a>
                </div>
              </div>
            ) : (
              <div className="mobile-menu-item">
                <div className="auth-section">
                  <a href="/users/login" className="mt-3 btn-default btn-small mb-3 w-100">
                    Sign In
                  </a>
                  <a href="/users/register" className="btn-default btn-small btn-outline-primary w-100">
                    Register
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderOne;